import { Link } from "react-router-dom";
import { LogOut } from "lucide-react";
import { useAuth } from "../contexts/AuthContext";

export const Navbar = () => {
  const { user, logout } = useAuth();

  return (
    <nav
      data-testid="main-navbar"
      className="sticky top-0 z-40 w-full bg-brand/80 backdrop-blur-2xl border-b border-brand-mint/15"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link
          to="/"
          data-testid="navbar-brand-link"
          className="flex items-center gap-3 group"
        >
          <img
            src="https://customer-assets.emergentagent.com/job_launch-agents/artifacts/09567i82_launchhub.png"
            alt="LaunchHub"
            className="h-10 w-10 rounded-full object-cover ring-1 ring-brand-mint/30 group-hover:ring-brand-mint/60 transition-all"
          />
          <span className="text-lg font-bold tracking-tight text-brand-mint">
            Launch<span className="text-brand-mint/70">Hub</span>
          </span>
        </Link>
        <div className="flex items-center gap-3 sm:gap-5 text-sm">
          <span className="hidden sm:flex items-center gap-2 text-brand-mint/70">
            <span className="h-1.5 w-1.5 rounded-full bg-brand-mint animate-pulse" />
            <span data-testid="navbar-status-label">Claude Opus 4.5</span>
          </span>
          {user && (
            <>
              <span
                data-testid="navbar-user-email"
                className="hidden md:inline text-brand-mint/80 max-w-[200px] truncate"
              >
                {user.email}
              </span>
              <button
                onClick={logout}
                data-testid="navbar-logout-btn"
                className="inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg text-brand-mint/75 hover:text-brand-mint border border-brand-mint/20 hover:border-brand-mint/50 transition-colors"
                aria-label="Sign out"
              >
                <LogOut className="h-4 w-4" />
                <span className="hidden sm:inline">Sign out</span>
              </button>
            </>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
